import axios from "axios";
import { API_URL } from "../../../support/api";
import { PaginatedValue } from "../../../support/utils";
import { IRole } from "../../role-and-permission/pages/roles/Role";
import { IMember } from "../models/Member";

export const LIST_USERS_URL = `${API_URL}/v1/user-management/users`;
export const GET_ALL_ROLES_URL = `${API_URL}/v1/role-and-permission/roles`;
export const CREATE_MEMBER_URL = `${API_URL}/v1/user-management/users`;

export const getMembers = async (search = "", status = "") => {
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  if (status) params.append("status", status);
  const queryString = params.toString();

  const response = await axios.get<{ value: PaginatedValue<IMember> }>(
    `${LIST_USERS_URL}${queryString ? `?${queryString}` : ""}`
  );

  return response.data.value;
};

// Approve a pending registrant, assigning the chosen role. The account moves to
// "approved" and is emailed to log in and enrol in 2FA.
export const approveMember = (member_id: number, role_id: number) => {
  return axios.post<{ value: IMember }>(
    `${LIST_USERS_URL}/${member_id}/approve`,
    { role_id }
  );
};

// Reject a pending registrant.
export const rejectMember = (member_id: number) => {
  return axios.post<{ value: IMember }>(
    `${LIST_USERS_URL}/${member_id}/reject`
  );
};

export const getAllRoles = () => {
  return axios.get<{ data: Array<IRole> }>(GET_ALL_ROLES_URL);
};

export const createMember = (payload: IMember) => {
  return axios.post(CREATE_MEMBER_URL, payload);
};

export const viewMember = (member_id: number | string) => {
  return axios.get<{ value: IMember }>(
    `${API_URL}/v1/user-management/users/${member_id}/view`
  );
};

export const updateMember = (payload: IMember) => {
  return axios.post<{ value: IMember }>(
    `${API_URL}/v1/user-management/users/${payload.id}/update`,
    payload
  );
};

export const deleteMember = (payload: IMember) => {
  return axios.post<{ value: IMember }>(
    `${API_URL}/v1/user-management/users/${payload.id}/delete`
  );
};
